import React, { Component } from 'react';
import {Route, Routes, useNavigate} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './index';
import { Layout } from './components/Layout';
import './custom.css';

export default function App() {
    return (
        <MsalProvider instance={msalInstance}>
            <Layout>
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                    })}
                </Routes>
            </Layout>
        </MsalProvider>
    );
}
